<!-- 物流公司详情 -->
<template>
  <div class="company-list flex-column">
    <div class="search d-flex justify-content-between align-items-center">
      <!-- 自定义返回组件 -->
      <!--<go-back>-->
      <i class="fa fa-angle-left" @click="back"></i>
      <!--</go-back>-->

      <div
        class="clearfix d-flex search-box justify-content-between align-items-center"
      >
        <input
          type="search"
          ref="inputClose"
          @keypress="searchLine"
          v-model="params.seachKey"
          class="flex-fill"
          placeholder="输入物流公司,路线"
        />
        <span class="clearfix flex-fill" @click.stop="getData('search')">
          <i class="fa fa-search"></i>
        </span>
      </div>

      <div class="share" @click="share">分享</div>
    </div>
    <!-- 地址选择 -->
    <div
      class="d-flex justify-content-between align-items-center select-addres"
    >
      <div @click="pickAddress('start')">
        <span class="select-down clearfix start">
          始发地
          <i class="fa fa-caret-down"></i>
        </span>
        <h4 v-if="!params.startCityName && !params.startAreaName">全部</h4>
        <h4 v-else>{{ params.startAreaName || params.startCityName }}</h4>
      </div>
      <div class="line-img">
        <img src="@/assets/imgs/icons/car.png" alt />
      </div>
      <div @click="pickAddress('end')">
        <span class="select-down clearfix end">
          目的地
          <i class="fa fa-caret-down"></i>
        </span>
        <h4 v-if="!params.destCityName && !params.destAreaName">全部</h4>
        <h4 v-else>{{ params.destAreaName || params.destCityName }}</h4>
      </div>
    </div>
    <div class="flex-column-1 none-collect" v-show="!companysData.join(',')">
      <div class="none-data">暂无数据</div>
    </div>
    <div
      v-show="companysData.join(',')"
      class="list-detail flex-column-1"
      :style="{ '-webkit-overflow-scrolling': scrollMode }"
    >
      <v-loadmore
        id="ZXLB"
        style="min-height: 100%;"
        :auto-fill="true"
        ref="loadMore"
        :top-method="loadTop"
        :bottom-method="loadBottom"
        :bottom-all-loaded="allLoaded"
      >
        <ul class="all-company">
          <!-- 这里多加了个index作为参数 正式的时候去掉 尽量用id 路由参数也需要修改 -->
          <div
            tag="li"
            @click="toDetail(company.organizationId)"
            v-for="(company, index) in companysData"
            :key="index"
            class="d-flex flex-fill company-detail-item"
          >
            <div class="dv-pic">
              <img
                class="img-fluid"
                :src="getImgUrl(company.companyLogo)"
                alt=""
              />
            </div>
            <div class="text-detail">
              <h3 class="tiles company-name">{{ company.companyName }}<spen v-if="company.isTop" style="float: right;color: white;background-color: #26a2ff;padding:4px 12px;font-size: 12px;">置顶</spen></h3>
              <h4 class="tiles addre-name">
                直达线路:{{ `${company.startCity}-${company.destCity}` }}
              </h4>
              <h5 class="tiles detail-addre-name-tel">
                地址:{{ company.companyAddr }}
              </h5>
              <h5 class="tiles detail-addre-name-tel">
                电话:{{ company.servicePhoneNo }}
              </h5>
              <Label :companyLabels="company.companyLabel" />
              <span
                class="rounded-tel"
                @click.stop="callNum(company.servicePhoneNo)"
              >
                <i class="fa fa-phone"></i>
              </span>
            </div>
          </div>
        </ul>
        <div class="more_loadings">
          <span v-show="allLoaded && companysData.length != 0"
            >这是我的底线啦!!!</span
          >
        </div>
        <div slot="bottom" class="mint-loadmore-bottom">
          <span v-show="!allLoaded">加载更多</span>
        </div>
      </v-loadmore>
    </div>
    <transition name="fade">
      <cityPick
        @emitCity="emitCity"
        chooseArea="true"
        @closePick="showPickCity = false"
        v-if="showPickCity"
      ></cityPick>
    </transition>
  </div>
</template>

<script>
import Label from "@/components/function/label/label.vue";
import { companys } from "@/assets/mock.data";
import { Loadmore } from "mint-ui";
import { Toast } from "mint-ui";
import { GET_COMPANY_ROUTE_LINE } from "@/assets/configs/api/otmsApi.js";
import { SAVE_SEARCH_HISTORY } from "@/assets/configs/api/otmsApi";
import { GET_COMPANY_ROUTE_LINE_PARK } from "@/assets/configs/api/otmsApi";


export default {
  components: {
    Label,
    "v-loadmore": Loadmore
  },
  data() {
    return {
      allLoaded: false,
      showPickCity: false,
      isLoadBottom: true,
      topStatus: "drop",
      scrollMode: "touch",
      companysData: [],
      companysTopData: [],
      direction: null,
      params: {
        pages: 1,
        pageSize: 10,
        seachKey: "",
        startCityName: "",
        startAreaName: "",
        destAreaName: "",
        destCityName: ""
      }
    };
  },
  computed: {
    companys() {
      return companys.splice(0, 10);
    }
  },
  methods: {
    getImgUrl(imgUrl) {
      var t = new Date().getTime();
      return imgUrl + `?t=${t}`;
    },
    saveHistory() {
      this.$post(
        SAVE_SEARCH_HISTORY,
        {
          startCityName: this.params.startCityName,
          destCityName: this.params.destCityName,
          identity: sessionStorage.getItem("useCompany"),
          appUserId: localStorage.getItem("customerId")
        },
        data => {
          console.log(data);
        },
        error => {
          Toast(error);
        }
      );
    },
    back() {
      this.$router.push({ name: "home", query: {} });
    },
    searchLine(event) {
      if (event.keyCode == 13) {
        this.$refs.inputClose.blur();
        event.preventDefault();
        this.getData("search");
      }
    },
    share() {
      let isWx = this.isWeiXin();
      if (isWx) {
        Toast("点击右上角分享");
      }
    },
    callNum(num) {
      window.location.href = "tel://" + num;
    },
    pickAddress(direction) {
      this.direction = direction;
      this.showPickCity = true;
    },
    loadTop() {
      this.getData("search");
    },
    loadBottom() {
      this.getData();
    },
    //获取数据列表
    getData(type) {
      if (type == "search") {
        this.allLoaded = false;
        this.params.pages = 1;
      }
      if (this.params.startCityName == "全部") {
        this.params.startCityName = "";
      }
      if (this.params.destCityName == "全部") {
        this.params.destCityName = "";
      }
      if (this.params.startAreaName == "全市") {
        this.params.startAreaName = "";
      }
      if (this.params.destAreaName == "全市") {
        this.params.destAreaName = "";
      }

      if(this.$route.query.startCity){
        this.params.startCityName = this.$route.query.startCity;
      }else if(this.$route.query.startArea){
        this.params.startAreaName = this.$route.query.startArea;
      }
      
      this.$post(
        GET_COMPANY_ROUTE_LINE,
        this.params,
        data => {
          this.$refs.loadMore.onTopLoaded(this.$refs.loadMore.$el.id);
          this.$refs.loadMore.onBottomLoaded(this.$refs.loadMore.$el.id);
          if (type == "search") {
            this.companysData = [];
          }
          if(this.companysData.length == 0){
           	 this.companysTopData.forEach(item => {
	               this.companysData.push(item);
	           });
          }
          if (data.list.length < 10) {
            this.allLoaded = true;
          }
          if (data.list.length != 0) {
            this.saveHistory();
            data.list.forEach(item => {
              this.companysData.push(item);
            });
            this.params.pages += 1;
          } else {
            this.allLoaded = true;
          }
        },
        error => {}
      );
    },
    toDetail(organizationId) {
      this.$router.push({
        name: "company-detail",
        query: { organizationId: organizationId }
      });
    },
    emitCity(data) {
      if (this.direction == "start") {
        if (data.cityText) {
          this.params.startCityName = data.cityText;
          this.params.startAreaName = data.areaText;
        }
      } else if (this.direction == "end") {
        if (data.cityText) {
          this.params.destCityName = data.cityText;
          this.params.destAreaName = data.areaText;
        }
      }
      this.allLoaded = false;
      this.companysData = [];
      this.params.pages = 1;
      this.getData();
      this.showPickCity = false;
    },
    getTopData(parkCode){
    	this.$post(
        GET_COMPANY_ROUTE_LINE_PARK,
        {parkCode:parkCode},
        data => {
           data.forEach(item => {
           	  item.isTop = true;
              this.companysTopData.push(item);
           });
           this.getData();
        },
        error => {}
      );
    }
  },
  mounted() {
    this.commonShare(
      location.href,
      "专线列表",
      "来这里找最好的物流专线",
      location.href
    );
    this.startLevel = this.$route.query.startLevel;
    this.endLevel = this.$route.query.endLevel;

    if (this.startLevel == "area") {
      this.params.startAreaName = this.$route.query.start
        ? this.$route.query.start
        : "";
    } else {
      this.params.startCityName = this.$route.query.start
        ? this.$route.query.start
        : "";
    }

    if (this.endLevel == "area") {
      this.params.destAreaName = this.$route.query.end
        ? this.$route.query.end
        : "";
    } else {
      this.params.destCityName = this.$route.query.end
        ? this.$route.query.end
        : "";
    }
    this.params.seachKey = this.$route.query.seachKey
    //义乌公路港
    if (sessionStorage.getItem("useCompany") == "ywglg") {
    		this.getTopData('1631');
    }else{
    	  this.getData();
    }
    wx.miniProgram.postMessage({ data: { shareURL: location.href } });
  }
};
</script>

<style scoped lang="scss">
@import "./list.scss";
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.company-list .fa-angle-left {
  margin-left: 0.2rem;
}
</style>
